const GuardiansTableColumns = [
    { id: 'full_name', labelAr: 'الاسم', labelEn: 'Name' },
    { id: 'relationship', labelAr: 'صلة القرابة', labelEn: 'Relationship', width: 120 },
    { id: 'phone', labelAr: 'الهاتف', labelEn: 'Phone', width: 130 },
    { id: 'whatsapp', labelAr: 'واتساب', labelEn: 'WhatsApp', width: 130 },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 80 },
];

export default GuardiansTableColumns;
